import React from 'react';
import MainHome from '../components/main/MainHome';
import MeteorBackground from '../components/background/MeteorShower';
import FallingStars from '../components/background/FallingStars';
import SpiderManEffect from '../components/background/SpiderManEffect';

function HomePage({ toggle, setToggle, backgroundEffect }) {
    return (
        <div>
            <MainHome />

            {/* Render background effect based on the state */}
            <div className='hidden lg:block'>
            {backgroundEffect === 'meteor' && <MeteorBackground toggle={toggle} setToggle={setToggle} />}
            {backgroundEffect === 'stars' && <FallingStars toggle={toggle} setToggle={setToggle} />}
            {backgroundEffect === 'spider' && <SpiderManEffect toggle={toggle} setToggle={setToggle} />}
            </div>
        </div>
    );
}

export default HomePage;
